//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageMixin from '~/mixins/page'

export default {
  mixins: [
    PageMixin
  ],
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t('affiliateProgram.seo.title'),
        description: this.$t('affiliateProgram.seo.description'),
        url: 'https://get-base.com/affiliate-program',
        link: [
          {
            rel: 'preload',
            as: 'image',
            href: this.getStaticsObject('/affiliate-program/hero.webp')
          },
          {
            rel: 'preload',
            type: 'font/ttf',
            href: this.getStaticsObject('/fonts/Swiss721MediumBT.ttf'),
            as: 'font',
            crossorigin: true
          }
        ]
      })
    }
  },
  computed: {
    testimonials () {
      return this.$t('general.testimonialsVideo.testimonials')
    }
  }
}
